<template>
    <div>
        <div
            class="py-10 bg-cover"
            :style="{
                backgroundImage: `url(${backgroundImage})`,
                backgroundColor
            }"
        >
            <h2 class="font-primary text-4xl text-white text-center text-white">
                {{ title }}
            </h2>

            <div class="w-full">
                <slider :items="series" :options="sliderOptions">
                    <template v-slot="{ item: serie }">
                        <serie :serie="serie"></serie>
                    </template>
                </slider>
            </div>
        </div>
    </div>
</template>

<script>
import Slider from "./Slider";
import Serie from "./Serie";

export default {
    name: "series-section",

    components: { Slider, Serie },

    props: {
        title: {
            type: String,
            required: true
        },

        series: {
            type: Array,
            required: true
        },

        backgroundImage: {
            type: String,
            required: true
        },

        backgroundColor: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            sliderOptions: {
                slidesPerView: 1.5,
                centeredSlides: true,
                initialSlide: 1,
                breakpoints: {
                    576: {
                        slidesPerView: 1,
                        centeredSlides: false,
                        initialSlide: 0
                    },
                    992: {
                        slidesPerView: 4,
                        centeredSlides: false,
                        initialSlide: 0
                    },
                    1200: {
                        slidesPerView: 5,
                        centeredSlides: false,
                        initialSlide: 0
                    }
                }
            }
        };
    }
};
</script>
